export default { sha: 'de893d59f511426550b1be14b171e8ca77dfb9e4', buildNumber: 'undefined' }
